// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inline-titulo-form.has-error #cadastro-form-titulo {\n  border-bottom-color: #a94442 !important;\n}", ""]);
// Exports
module.exports = exports;
